import React from "react";

interface CustomDateProps {
  id: string;
  className?: string;
  value: string | number;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const CustomDate: React.FC<CustomDateProps> = ({ id, className, value, onChange }) => {
  return (
    <input
      id={id}
      type="date"
      className={`form-control ${className || ""}`}
      value={value}
      onChange={onChange}
    />
  );
};

export default CustomDate;